import { memo, FC } from "react";
import { Link, Td, Textarea, Tr } from "@chakra-ui/react";
import { EditIcon, EmailIcon, ExternalLinkIcon } from "@chakra-ui/icons";

type Props = {
  name: string;
  eventsRuleName: string;
  lambdaName: string;
  parampath: string;
  onClick: (parampath: string) => void;
};

export const TenantJobRow: FC<Props> = memo((props) => {
  const {
    name,
    eventsRuleName,
    lambdaName,
    parampath,
    onClick,
  } = props;

  return (
    <Tr key={parampath} bg="gray.50">
      <Td>
        <Link onClick={() => onClick(parampath)} isExternal>
          {name}
          <EditIcon mx="2" color={"gray"} fontSize="sm" />
        </Link>
      </Td>
      <Td>{eventsRuleName}</Td>
      <Td>{lambdaName}</Td>
    </Tr>
  );
});
